﻿import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { DrawerService } from "@app/services/drawer.service";
import { CrudController } from "@app/views/crud.view";
import { IRootScope } from "@models";
import { StateService } from "@uirouter/angularjs";

export interface IUserActivationModel {
    password?: string;
    confirmPassword?: string;
    agreedToPrivacyPolicy?: boolean;
}
export interface IUserActivationScope {
    save: () => void;
    model: IUserActivationModel;
    validation: any;
    goToLogin: () => void;
    /**
     * eUserActivationMode: password or thanks.  Sometimes activations require passwords to be reset.
     * If so, it will be in the url
     */
    mode: string;
    isNew: boolean;
    userActivationGuid: string;
}

export enum eUserActivationMode {
    password = "password",
    thanks = "thanks",
    invalid = "invalid"
}

@NgView({
    token: Token.UserActivationView,
    dependencies: [
        Token.$Scope,
        Token.$RootScope,
        Token.DrawerService,
        Token.$Http,
        Token.$StateParams,
        Token.$State
    ]
})
export class UserActivationController {
    constructor(
        public $scope: IUserActivationScope,
        $rootScope: IRootScope,
        drawerService: DrawerService,
        $http: ng.IHttpService,
        $stateParams: any,
        $state: StateService
    ) {
            drawerService.setHelpUrl(null);

            $rootScope.user = {
                id: $stateParams.idUser
            };
            $scope.model = {};

            $rootScope.setTitle(loc.user_activation);

        $http.post(
            "api/users/activate?idUser=" + $stateParams.idUser +
            "&activationGuid=" + $stateParams.activationGuid,
            {
                password: "",
            },
            { tracker: $rootScope.contentTracker }
        ).then((r: any) => {

            $scope.userActivationGuid = r.data.activationGuid;
            $scope.isNew = r.data.isNew;
            if (r.data.requiresPassword) {
                $scope.mode = eUserActivationMode.password;
            } else {
                $scope.mode = eUserActivationMode.thanks;
            }

        }, (r) => {
            $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
            $scope.mode = eUserActivationMode.invalid;
        });

                

        $scope.save = () => {
            $scope.validation = {};
                if ($scope.model.password != $scope.model.confirmPassword) {
                    $scope.validation.confirmPassword = "Passwords do not match.";
                }
                if ($scope.isNew && !$scope.model.agreedToPrivacyPolicy) {
                    $scope.validation.agreedToPrivacyPolicy = "Must agree to the privacy policy";
                }
            if ($scope.validation.confirmPassword || $scope.validation.agreedToPrivacyPolicy) return;
            return $http.post(
                "api/users/activate?idUser=" + $stateParams.idUser +
                "&activationGuid=" + $scope.userActivationGuid,
                {
                    password: $scope.model.password,
                    agreed: $scope.model.agreedToPrivacyPolicy
                },
                    { tracker: $rootScope.contentTracker }
                ).then(() => {
                    $scope.mode = eUserActivationMode.thanks;
                }, (r) => {
                    $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
                });
            };

            $scope.goToLogin = () => {
                window.location.href = "/";
            };
        }
}
